import {WixSdk} from '@wix/js-sdk-wrapper';
import {tap} from 'rxjs/operators';
import {debugSettings} from './debugPanel';
import {noop} from './functions';

const compId = WixSdk.Utils.getCompId();
let previous: number;

function align(scope: string, size: number) {
  return (scope + ' '.repeat(20)).slice(0, size);
}

const messages: any[] = [];
const debugLog = console.debug.bind(console);
const prodLog = (...args: any[]) => {
  messages.push(args);
};
const env = process.env.NODE_ENV;
let logger = env === 'test' ? noop : debugSettings.debugEnabled ? debugLog : prodLog;

(window as any).printLog = () => {
  logger = debugLog;
  messages.forEach((args) => {
    console.log(...args);
  });
};

export const debugScoped = (scope: string, message: string, ...args: any[]) => {
  // todo: i am not sure it should be window.name, but "name" doesn't exist and now TS complains about it
  performance.mark && performance.mark(window.name);
  const now = performance.now();
  if (!previous) {
    previous = now;
  }
  const duration = align((now - previous).toFixed(), 3);
  previous = now;
  const alignedScope = align(scope, 11);
  logger(`[music: ${compId}: ${alignedScope} +${duration}] `, message, ...args);
};
export const debug = <T>(scope: string, message: string, includeValue = false) =>
  tap<T>((v) => (includeValue ? debugScoped(scope, message, v) : debugScoped(scope, message)));
